import { createSelector } from 'reselect';
import modalsSelector from 'selectors/modals/modalsSelector';

const focusTargetIdSelector = createSelector(modalsSelector, modals => modals.focusTargetId);

export default focusTargetIdSelector;
